import Login from "../components/views/Login.vue";
import RegistrarLicenca from "../components/views/RegistrarLicenca";
import BuscarLicenca from "../components/views/BuscarLicenca";
import ListagemRemessa from "../components/business/remessa/ListagemRemessa";
import EnvioListagemRetorno from "../components/business/remessa/EnvioListagemRetorno";
import store from "../configs/store"; // Alterado de IndexStore para store
import { GET_USUARIO } from "../store/actions.type";
import MinhasLicencas from "../components/views/MinhasLicencas.vue";
import NovoCadastro from "../components/views/NovoCadastro.vue";
import InformesIpaam from "../components/views/InformesIpaam.vue";
import InformeDetalhe from "../components/views/InformeDetalhe.vue";
import AutenticidadeQr from "../components/views/AutenticidadeQr.vue";

export const routes = [
  {
    path: "/",
    component: MinhasLicencas,
    name: "home",
    beforeEnter: async (to, from, next) => {
      BuscaUsuarioLogado(next);
    },
  },
  {
    path: "/registrar",
    name: "registrar",
    component: RegistrarLicenca,
  },
  {
    path: "/listagem-remessas",
    name: "listagemRemessa",
    component: ListagemRemessa,
  },
  {
    path: "/envio-retorno",
    name: "envioListagemRetorno",
    component: EnvioListagemRetorno,
  },
  {
    path: "/informacao-carteira/:protocolo",
    name: "informacao-carteira",
    component: AutenticidadeQr,
  },
  {
    path: "/consultar/:protocolo",
    name: "consultar",
    // Lazy loading
    component: () => import("../components/views/ConsultarLicenca"),
  },
  {
    path: "/renovar/:protocolo",
    name: "renovar",
    component: () => import("../components/views/RenovarLicenca"),
  },
  {
    path: "/novo-cadastro",
    name: "novoCadastro",
    component: NovoCadastro,
    beforeEnter: async (to, from, next) => {
      BuscaUsuarioLogado(next);
    },
  },
  {
    path: "/informes-ipaam",
    name: "informesIpaam",
    component: InformesIpaam,
  },
  {
    path: "/informe/:id",
    name: "InformeDetalhe",
    component: InformeDetalhe,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
];

function BuscaUsuarioLogado(next) {
  store
    .dispatch(GET_USUARIO)
    .then((usuario) => {
      if (usuario.login) {
        next();
      } else {
        next("/login");
      }
    })
    .catch(() => {
      next("/login");
    });
}
